/**
 * @generated SignedSource<<eb765d9a1900b57a5b107d7533d14daf>>
 * @relayHash 91fd89667bec7931202da894b6f488e2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9bad257db00b0b6b150b26f9416723108493e81ae89acfc43a85301dd6e49df3

import type { ConcreteRequest } from 'relay-runtime';
export type WorkforceNotificationsQuery$variables = {
  cloudId: string;
};
export type WorkforceNotificationsQuery$data = {
  readonly agentWorkspace_myShiftNotificationPreferences: ReadonlyArray<{
    readonly project: {
      readonly avatar: {
        readonly small: string | null;
      } | null;
      readonly name: string;
    } | null;
    readonly projectId: string;
    readonly shiftReminderEnabled: boolean;
  }> | null;
};
export type WorkforceNotificationsQuery = {
  response: WorkforceNotificationsQuery$data;
  variables: WorkforceNotificationsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "projectId"
},
v3 = {
  "kind": "ScalarField",
  "name": "shiftReminderEnabled"
},
v4 = {
  "kind": "ScalarField",
  "name": "name"
},
v5 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "small"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "WorkforceNotificationsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "AgentWorkspaceShiftNotificationPreference",
        "kind": "LinkedField",
        "name": "agentWorkspace_myShiftNotificationPreferences",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WorkforceNotificationsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "AgentWorkspaceShiftNotificationPreference",
        "kind": "LinkedField",
        "name": "agentWorkspace_myShiftNotificationPreferences",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "9bad257db00b0b6b150b26f9416723108493e81ae89acfc43a85301dd6e49df3",
    "metadata": {},
    "name": "WorkforceNotificationsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "a44aa51dc1d9b54524ee0a4baab2fd5c";

export default node;
